// extracted by mini-css-extract-plugin
export var anchorPointer = "MediaLogoSection-module--anchorPointer--82f2a";
export var bgOverlay = "MediaLogoSection-module--bgOverlay--54be7";
export var columnContainer1 = "MediaLogoSection-module--columnContainer1--ce2a2";
export var columnContainer2 = "MediaLogoSection-module--columnContainer2--de8fd";
export var container = "MediaLogoSection-module--container--06d83";
export var ctaWrapper = "MediaLogoSection-module--ctaWrapper--31025";
export var focusVisible = "MediaLogoSection-module--focus-visible--d3674";
export var headlineContainer = "MediaLogoSection-module--headlineContainer--ef64f";
export var horizontalLine = "MediaLogoSection-module--horizontalLine--0bcb6";
export var iconGrid = "MediaLogoSection-module--iconGrid--0cf6f";
export var iconImage = "MediaLogoSection-module--iconImage--5cca4";
export var iconItem = "MediaLogoSection-module--iconItem--33583";
export var iconTitle = "MediaLogoSection-module--iconTitle--4a2c8";
export var imageBlock = "MediaLogoSection-module--imageBlock--c21f7";
export var imageContainer = "MediaLogoSection-module--imageContainer--25610";
export var logoGrid = "MediaLogoSection-module--logoGrid--09cbd";
export var logoImage = "MediaLogoSection-module--logoImage--b20dc";
export var logoItem = "MediaLogoSection-module--logoItem--9be28";
export var mediaContainer = "MediaLogoSection-module--mediaContainer--13d19";
export var mediaTitle = "MediaLogoSection-module--mediaTitle--6c469";
export var mobilePictureContainer = "MediaLogoSection-module--mobilePictureContainer--5abc7";
export var pictureContainer = "MediaLogoSection-module--pictureContainer--31e32";
export var pictureImg = "MediaLogoSection-module--pictureImg--1cb40";
export var starIcon = "MediaLogoSection-module--starIcon--bbcb9";
export var stars = "MediaLogoSection-module--stars--7e0b2";
export var subHeadlineContainer1 = "MediaLogoSection-module--subHeadlineContainer1--f1110";
export var subHeadlineContainer2 = "MediaLogoSection-module--subHeadlineContainer2--6e768";
export var textBlock = "MediaLogoSection-module--textBlock--4331a";
export var upperTextBlock = "MediaLogoSection-module--upperTextBlock--a45a4";